var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlide4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250.922,
    height: 177.311,
    viewBox: "0 0 250.922 177.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "slide5",
    transform: "translate(-390 -214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(390 214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M487.06,601.8l-5.369-2.261-3.683-26.914H428.962l-3.992,26.8-4.8,2.4a1.141,1.141,0,0,0,.51,2.161h65.94a1.141,1.141,0,0,0,.442-2.192Z",
    transform: "translate(-328.309 -426.679)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M503.623,536.564H262.243c-2.637,0-4.771-1.468-4.771-3.273V510H508.394v23.292c0,1.8-2.134,3.269-4.771,3.273Z",
    transform: "translate(-257.472 -374.937)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M508,420.6H257.08V275.234a5.761,5.761,0,0,1,5.754-5.754H502.248A5.761,5.761,0,0,1,508,275.234Z",
    transform: "translate(-257.08 -269.48)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M516.094,434.352H280.6a4.866,4.866,0,0,1-4.728-4.984V293.252a4.867,4.867,0,0,1,4.728-4.984h235.5a4.867,4.867,0,0,1,4.728,4.984V429.367A4.866,4.866,0,0,1,516.094,434.352Z",
    transform: "translate(-272.884 -285.897)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(444.23 230.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M588.843,658.79H518.968a1.3,1.3,0,0,1-1.294-1.294V640.163a1.3,1.3,0,0,1,1.294-1.294h69.876a1.3,1.3,0,0,1,1.294,1.294V657.5A1.3,1.3,0,0,1,588.843,658.79Zm-69.876-19.4a.777.777,0,0,0-.776.776V657.5a.777.777,0,0,0,.776.776h69.876a.777.777,0,0,0,.776-.776V640.163a.777.777,0,0,0-.776-.776Z",
    transform: "translate(-472.638 -527.365)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 5.271,
    cy: 5.271,
    r: 5.271,
    transform: "translate(51.916 115.528)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M615.278,662.72a.878.878,0,0,0,0,1.757h41.415a.878.878,0,1,0,0-1.757Z",
    transform: "translate(-545.918 -545.435)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M615.278,684.466a.878.878,0,1,0,0,1.757H633.1a.878.878,0,1,0,0-1.757Z",
    transform: "translate(-545.918 -561.909)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M660.844,552.79H590.968a1.3,1.3,0,0,1-1.294-1.294V534.163a1.3,1.3,0,0,1,1.294-1.294h69.876a1.3,1.3,0,0,1,1.294,1.294V551.5A1.3,1.3,0,0,1,660.844,552.79Zm-69.876-19.4a.777.777,0,0,0-.776.776V551.5a.777.777,0,0,0,.776.776h69.876a.777.777,0,0,0,.776-.776V534.163a.777.777,0,0,0-.776-.776Z",
    transform: "translate(-527.185 -447.059)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 5.271,
    cy: 5.271,
    r: 5.271,
    transform: "translate(69.368 89.834)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M687.278,556.72a.878.878,0,1,0,0,1.757h41.415a.879.879,0,1,0,0-1.757Z",
    transform: "translate(-600.465 -465.129)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M687.278,578.466a.879.879,0,1,0,0,1.757H705.1a.879.879,0,1,0,0-1.757Z",
    transform: "translate(-600.465 -481.604)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M604.844,241.21H534.968a1.3,1.3,0,0,1-1.294-1.294V180.163a1.3,1.3,0,0,1,1.294-1.294h69.876a1.3,1.3,0,0,1,1.294,1.294v59.753A1.3,1.3,0,0,1,604.844,241.21Zm-69.876-61.824a.777.777,0,0,0-.776.776v59.753a.777.777,0,0,0,.776.776h69.876a.777.777,0,0,0,.776-.776V180.163a.777.777,0,0,0-.776-.776Z",
    transform: "translate(-484.76 -178.869)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 5.271,
    cy: 5.271,
    r: 5.271,
    transform: "translate(55.794 46.445)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M631.278,377.72a.879.879,0,1,0,0,1.757h41.415a.879.879,0,1,0,0-1.757Z",
    transform: "translate(-558.039 -329.518)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M631.278,399.466a.879.879,0,1,0,0,1.757H649.1a.879.879,0,0,0,0-1.757Z",
    transform: "translate(-558.039 -345.993)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M341.43,377.163l.77,6.133a3.224,3.224,0,0,0,4.509,2.544h0a3.224,3.224,0,0,0,1.515-4.5l-3.239-5.89-1.059-25.323-6.85,1.6Z",
    transform: "translate(-335.817 -308.614)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M155.536,352.165l-5.333.485-3.151-43.874-.121,11.271L135.3,351.074l-4.606-3.636,7.636-30.906-3.636-17.21h23.755Z",
    transform: "translate(-124.267 -226.766)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M442.7,695.317l-9.914-.242a2.686,2.686,0,0,1-2.849-3.1l.406-2.552a2.184,2.184,0,0,1,2-1.836h0c1.692,1.751,3.442,1.493,5.239-.374l4.087,4.146.61-.082a2.033,2.033,0,0,1,2.224,1.449h0a2.033,2.033,0,0,1-1.8,2.593Z",
    transform: "translate(-406.146 -563.989)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M352.664,683.779l-9.942-3.751a2.871,2.871,0,0,1-1.369-4.289l1.542-2.293a2.335,2.335,0,0,1,2.766-.88h0c.854,2.459,2.667,2.995,5.249,1.991l2.536,4.918.629.195a2.173,2.173,0,0,1,1.505,2.405h0a2.173,2.173,0,0,1-2.915,1.7Z",
    transform: "translate(-338.687 -552.778)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 6.302,
    cy: 6.302,
    r: 6.302,
    transform: "translate(16.483 5.168)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M394.791,240.857l-10.908-.242c3-3.316,4.818-6.775,5.09-10.423h5.818Z",
    transform: "translate(-371.278 -217.751)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M381.554,317.943c-10.3-2.642-19.958-4.423-25.937-1.212,1.047-11.008-.164-25.059-3.757-39.745-1.167-4.77-.375-9.068,3.878-11.522l5.7-3.272,8.726.242,4.553,2.519a11.432,11.432,0,0,1,6.122,12.357C378.39,290.182,379.712,304.076,381.554,317.943Z",
    transform: "translate(-346.649 -241.994)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M455.337,379.885l.854,6.122a3.224,3.224,0,0,1-3.691,3.631h0a3.224,3.224,0,0,1-2.635-3.949l1.593-6.53-5.575-24.725,7.03-.242Z",
    transform: "translate(-418.249 -311.693)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M343.276,302.31l-11.393-.727c.89-11.207,3.423-17.334,7.272-19.392l4.121,4.848Z",
    transform: "translate(-331.883 -257.146)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M408.419,196.388c-2.22-.71-3.373,3.843-6.666,6.666-.749.642-2.616-1.861-3.272-1.091l-1.061-3.228a6.836,6.836,0,0,1,4.952-8.846q.157-.034.317-.06h0a7.068,7.068,0,0,1,7.968,5.069.935.935,0,0,1-.709,1.152Z",
    transform: "translate(-381.27 -187.098)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M222.34,130.351l-10.666,2.424-.485-17.453,6.06.242Z",
    transform: "translate(-185.253 -87.368)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M673.333,246.144H603.457a1.3,1.3,0,0,1-1.294-1.294V214.185a1.3,1.3,0,0,1,1.294-1.294h69.876a1.3,1.3,0,0,1,1.294,1.294V244.85A1.3,1.3,0,0,1,673.333,246.144Z",
    transform: "translate(-536.647 -204.644)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M663.46,256.985a.879.879,0,1,0,0,1.757h41.416a.879.879,0,1,0,0-1.757Z",
    transform: "translate(-582.421 -238.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M663.46,277.985a.878.878,0,1,0,0,1.757h41.416a.878.878,0,1,0,0-1.757Z",
    transform: "translate(-582.421 -253.959)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M663.46,298.731a.879.879,0,1,0,0,1.757h17.821a.879.879,0,0,0,0-1.757Z",
    transform: "translate(-582.421 -269.676)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide4);
export default __webpack_public_path__ + "static/media/slide4.80319b10445f370d887886c25ff53f51.svg";
export { ForwardRef as ReactComponent };